import React, { useEffect, useState } from "react";
import { Button, Notification } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { FaFileSignature, FaMagnifyingGlass, FaChartBar } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const TableActions = ({
  onSearch = () => {},
  onEdit = () => {},
  onStats = () => {},          // ✅ NEW
  selectedRequestId = null,
}) => {
  const [query, setQuery] = useState("");
  const [notice, setNotice] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!notice) return;
    const t = setTimeout(() => setNotice(""), 3000); // auto-dismiss
    return () => clearTimeout(t);
  }, [notice]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };

  // Admin check (JWT payload first, then localStorage fallbacks)
  const isUserAdmin = () => {
    try {
      const token = localStorage.getItem("token") || "";
      if (token && token.split(".").length === 3) {
        const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(decodeURIComponent(escape(atob(b64))));
        const roles = []
          .concat(payload.role || [])
          .concat(payload.roles || [])
          .concat(payload.authorities || [])
          .concat(payload.scope || [])
          .map((r) => String(r).toLowerCase());
        if (
          roles.includes("admin") ||
          roles.includes("role_admin") ||
          roles.some((r) => r.includes("admin"))
        ) {
          return true;
        }
      }
    } catch {}
    try {
      const direct = (localStorage.getItem("role") || "").toLowerCase();
      if (direct.includes("admin")) return true;
      const userJson =
        localStorage.getItem("user") ||
        localStorage.getItem("userInfo") ||
        localStorage.getItem("profile");
      if (userJson) {
        const u = JSON.parse(userJson);
        const roles = []
          .concat(u?.role || [])
          .concat(u?.roles || [])
          .concat(u?.authorities || [])
          .map((r) => String(r).toLowerCase());
        if (roles.some((r) => r.includes("admin"))) return true;
      }
    } catch {}
    return false;
  };

  const handleCreateCareer = () => {
    if (!selectedRequestId) {
      setNotice("Select a request first.");
      return;
    }
    if (!isUserAdmin()) {
      setNotice("Only admin can create a vacancy.");
      return;
    }
    navigate(`/vacancy/${selectedRequestId}`);
  };

  // ✅ NEW: gated Stats open
  const handleOpenStats = () => {
    if (!selectedRequestId) {
      setNotice("Select a request first.");
      return;
    }
    if (!isUserAdmin()) {
      setNotice("Only admin can view stats.");
      return;
    }
    onStats(); // parent opens the modal
  };

  return (
    <div className="flex flex-wrap items-center w-full gap-y-2">
      {/* LEFT: Search (kept where it was) */}
      <div className="relative w-60">
        <FaMagnifyingGlass className="absolute text-gray-400 -translate-y-1/2 pointer-events-none left-4 top-1/2" />
        <input
          type="text"
          placeholder="Search by ID"
          value={query}
          onChange={handleSearchChange}
          className="w-full py-2 pl-10 pr-4 border border-gray-300 rounded-full focus:outline-none"
        />
      </div>

      {/* RIGHT: Buttons + right-aligned notification above them */}
      <div className="relative flex items-center ml-auto gap-x-3">
        {notice && (
          <div className="absolute right-0 bottom-full mb-2 z-50 w-[22rem] max-w-[90vw]">
            <Notification
              icon={<IconX size={16} />}
              color="red"
              radius="md"
              withCloseButton
              onClose={() => setNotice("")}
              title="Notice"
            >
              {notice}
            </Notification>
          </div>
        )}

        {/* Create Vacancy */}
        <Button
          onClick={handleCreateCareer}
          className="bg-gray-100 shadow-md font-MTNfont"
          variant="default"
          radius="md"
        >
          <span className="flex items-center gap-2">
            <FaFileSignature size={18} />
            Create Vacancy
          </span>
        </Button>
{/* 
        
        <Button
          className="bg-gray-100 shadow-md font-MTNfont"
          variant="default"
          radius="md"
          onClick={onEdit}
        >
          <span className="flex items-center gap-2">
            <FaFileSignature size={18} />
            Edit
          </span>
        </Button> */}

        {/* NEW: Stats (last, right of Edit) */}
        <Button
          className="bg-gray-100 shadow-md font-MTNfont"
          variant="default"
          radius="md"
          onClick={handleOpenStats}
        >
          <span className="flex items-center gap-2">
            <FaChartBar size={18} />
            Stats
          </span>
        </Button>
      </div>
    </div>
  );
};

export default TableActions;
